import React, { useState, useEffect, useRef, useCallback } from "react";
import { DeletePlayerPost, EditPlayerPost } from "../../../Config/API/player";
import Loader from "../../../common/cards/Loader";
import { Row, Spin, Col } from "antd";
import ShowCards from "../../../common/cards/FeedCard";
import NoData from "../../../common/cards/noData";

import { useFetchEventAnnoucements } from "../../../common/hooks/useFetchEventAnnoucements";

const DiscussionPlayer = ({ panelFound, teamFound }) => {
  const { fetchloading, POSTS, setPage, totalPages, page, fetchTime } =
    useFetchEventAnnoucements("player");

  const [posts, setPosts] = useState([]);
  const [loadMorePosts, setLoadMorePosts] = useState(false);

  const observer = useRef();
  const timer = useRef();
  const isThrottled = useRef(false);

  useEffect(() => {
    const fetchPosts = async () => {
      setPosts((prevPosts) => [...prevPosts, ...POSTS]);
      const timeoutDuration = Math.max(fetchTime + 100, 500);

      timer.current = setTimeout(() => setLoadMorePosts(false), timeoutDuration);
    };
    fetchPosts();
    return () => clearTimeout(timer.current);
  }, [POSTS, fetchTime]);

  const lastPostElementRef = useCallback(
    (node) => {
      if (fetchloading || isThrottled.current) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setLoadMorePosts(true);
            isThrottled.current = true;
            setTimeout(() => {
              isThrottled.current = false;
            }, 100);
            if (page < totalPages) setPage((prevPage) => prevPage + 1);
          }
        },
        {
          root: null,
          threshold: 0.1
        }
      );
      if (node) observer.current.observe(node);
    },
    [fetchloading, page, totalPages]
  );

  return (
    <Row className="mobileto">
      {fetchloading ? (
        <Loader />
      ) : (panelFound || teamFound) && posts?.length > 0 ? (
        <>
          {posts.map((data, index) => (
            <ShowCards
              key={data?._id || index}
              index={index}
              data={data}
              POSTS={posts}
              setPOSTs={setPosts}
              ref={posts.length === index + 1 ? lastPostElementRef : null}
              deletepost={DeletePlayerPost}
              editpost={EditPlayerPost}
            />
          ))}
          {loadMorePosts && page < totalPages && (
            <div style={{ textAlign: "center", margin: "20px", width: "100%" }}>
              <Spin tip="Loading more posts..." style={{ color: "black", fontSize: "12px" }} />
            </div>
          )}
        </>
      ) : (
        <Col span={24}>
          <NoData />
        </Col>
      )}
    </Row>
  );
};

export default DiscussionPlayer;
